import { getIntegrationsApiRequest } from '@/services/api/integrations-api';
import { useStore } from '@/store';

export const populateIntegrationsStoreCacheApiRequest = async () => {
  const store = useStore();
  const payload = await getIntegrationsApiRequest();
  store.cache.populateIntegrationsCache(payload);
  return payload;
};
